import React from 'react';

const SheetMetal = () => {
  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['air', 'precision_manufacturing', 'content_cut', 'ac_unit', 'thermostat', 'engineering', 'build_circle', 'handyman'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Professional Services
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              Sheet Metal Shop
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Custom sheet metal fabrication and HVACR ductwork solutions for commercial facilities
            </p>
          </div>
        </div>
      </section>

      {/* Section 1: Sheet Metal – A Coordinated Process */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Sheet Metal – A Coordinated Process</h2>
            <p>Integrated coordination for optimal project execution</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                During the construction of any project, the coordination of the trades is an integral part of the process, especially with respect to the <strong style={{color: 'var(--accent-blue)'}}>mechanical and electrical trades</strong>.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)'}}>
                Bel-Aire Mechanical's sheet metal division plays a crucial role in this coordination process, ensuring that ductwork systems integrate seamlessly with electrical, plumbing, and structural elements to deliver efficient and reliable HVAC solutions for commercial and mission-critical facilities.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Sheet Metal Coordination Process Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div style={{background: 'var(--secondary-light)', padding: '2.5rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: 0, textAlign: 'center'}}>
                Our coordinated approach ensures that sheet metal systems are designed and fabricated to work harmoniously with all building systems, maximizing efficiency and minimizing conflicts during installation.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Sheet Metal Manufacturing */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Sheet Metal Manufacturing</h2>
            <p>Skilled fabrication for custom and specialty applications</p>
          </div>
          
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center'}} className="precon-grid-2col">
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Sheet Metal Manufacturing Shop Image]
            </div>
            
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                The skilled fabricators in our shop can readily produce <strong style={{color: 'var(--accent-blue)'}}>one-of-a kind architectural and specialty sheet metal items from standard and exotic metals</strong>, as well as galvanized ductwork utilized in heating, ventilation and air conditioning applications.
              </p>
              
              <div style={{background: 'var(--accent-blue)', color: 'var(--white)', padding: '2rem', borderRadius: '10px'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem'}}>Manufacturing Capabilities</h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  From architectural metalwork for commercial buildings to precision HVAC ductwork for data centers and hospitals, our manufacturing capabilities span a wide range of materials and applications, ensuring we can meet any project requirement.
                </p>
              </div>
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '3rem auto 0'}}>
            <div className="sheetmetal-capabilities-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(4, 1fr)', 
              gap: '1rem'
            }}>
              <div className="sheetmetal-capability-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Architectural Metal</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Custom decorative and functional metalwork</p>
              </div>
              <div className="sheetmetal-capability-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>HVAC Ductwork</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Galvanized ductwork for HVAC applications</p>
              </div>
              <div className="sheetmetal-capability-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Specialty Items</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>One-of-a-kind custom fabrications</p>
              </div>
              <div className="sheetmetal-capability-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Exotic Metals</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Specialized materials for unique applications</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Custom / Specialty */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Custom / Specialty</h2>
            <p>Advanced technology for precision fabrication</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                Duct fittings are downloaded directly from the model to our <strong style={{color: 'var(--accent-blue)'}}>computerized plasma table to minimize waste, insure accuracy and increase productivity</strong>.
              </p>
              
              <div style={{background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 6px 25px rgba(171, 22, 54, 0.3)'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                  <span className="material-icons" style={{fontSize: '1.5rem'}}>precision_manufacturing</span>
                  Technology Integration
                </h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.8', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  Our computerized plasma cutting technology integrates seamlessly with our BIM modeling systems, ensuring that every custom fitting is fabricated to exact specifications with maximum efficiency and minimal material waste.
                </p>
              </div>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Computerized Plasma Table Image]
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Sheet Metal Manufacturing Highlights */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 50%, rgba(0, 104, 166, 0.1) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Sheet Metal Manufacturing Highlights</h2>
            <p>State-of-the-art equipment and advanced manufacturing capabilities</p>
          </div>
          
          <div style={{maxWidth: '1200px', margin: '0 auto'}}>
            <div className="sheetmetal-highlights-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(3, 1fr)', 
              gap: '1.5rem'
            }}>
              <div className="sheetmetal-highlight-card sheetmetal-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>precision_manufacturing</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Plasma Cutting Technology</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Fully programmable plasma table</li>
                  <li>Computerized precision cutting</li>
                  <li>Direct download from BIM models</li>
                  <li>Minimizes waste and maximizes accuracy</li>
                </ul>
              </div>
              
              <div className="sheetmetal-highlight-card sheetmetal-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>build</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Press Brake & Coil Lines</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>90 ton press brake</li>
                  <li>Multiple 5000lb coil line</li>
                  <li>High-capacity forming operations</li>
                  <li>Precision bending and shaping</li>
                </ul>
              </div>
              
              <div className="sheetmetal-highlight-card sheetmetal-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>category</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Material Capabilities</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Galvanized to 10 ga</li>
                  <li>Mild steel to 1/4"</li>
                  <li>Stainless steel to 3/16"</li>
                  <li>Wide range of material options</li>
                </ul>
              </div>
              
              <div className="sheetmetal-highlight-card sheetmetal-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>settings</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Welding Excellence</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Certified welding personnel</li>
                  <li>MIG, TIG and arc welding</li>
                  <li>Professional welding capabilities</li>
                  <li>Quality certified processes</li>
                </ul>
              </div>
              
              <div className="sheetmetal-highlight-card sheetmetal-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>precision_manufacturing</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Manufacturing Services</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Ductwork and custom manufacturing</li>
                  <li>Specialty fabrications</li>
                  <li>Architectural metalwork</li>
                  <li>Commercial applications</li>
                </ul>
              </div>
              
              <div className="sheetmetal-highlight-card sheetmetal-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>construction</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Material Handling</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>3 ton traversing bridge cranes</li>
                  <li>Interior and exterior crane systems</li>
                  <li>Minimizes material handling costs</li>
                  <li>Increased safety during operations</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SheetMetal;
